import type { AbilityEffect } from "./types.ts";

/**
 * Reading an ability's `effects` entries (ADR-079's amendment of 2026-10-21): each is an effect id, which lasts the
 * effect's own duration, or a record naming how long the effect lasts for that ability.
 */

/**
 * The effect id an entry names.
 *
 * @param entry An entry of an ability's `effects`.
 * @returns The effect's id.
 */
export function abilityEffectId(entry: AbilityEffect): string {
  return typeof entry === "string" ? entry : entry.effect;
}

/**
 * The ticks an entry names for its ability.
 *
 * @param entry An entry of an ability's `effects`.
 * @returns The ticks, or null when the effect lasts its own duration.
 */
export function abilityEffectTicks(entry: AbilityEffect): number | null {
  return typeof entry === "string" ? null : entry.durationTicks;
}
